import api from "../api";
import config from "../config";

export const genericService = {
  types: async () => {
    const res = await api.get(`${config.apiBaseUrl}/api/generic/types/`);
    return res.data?.results ?? [];
  },

  statuses: async () => {
    const res = await api.get(`${config.apiBaseUrl}/api/generic/status/`);
    return res.data?.results ?? [];
  },

  countries: async () => {
    const res = await api.get(`${config.apiBaseUrl}/api/generic/countries/`);
    return res.data?.results ?? [];
  },

  personFieldTypes: async () => {
    const res = await api.get(
      `${config.apiBaseUrl}/api/generic/person-field-types/`,
    );
    return res.data ?? {};
  },

  timezones: async () => {
    const res = await api.get(`${config.apiBaseUrl}/api/generic/timezones/`);
    return res.data ?? { default: null, timezones: [] };
  },
};
